import React from "react";
import { T } from "../app/tokens.js";

// Shared Office/Lease geometry stays unchanged; Updates opts into compact size.
export function HairlineNavButton({ label, ariaLabel = label, onClick, testId, disabled, titleText, compact = false }) {
  return <button type="button" data-chrome-action="pager" data-testid={testId}
    disabled={disabled} onClick={disabled ? undefined : onClick}
    data-pager-icon={label.startsWith("‹") ? "‹" : "›"}
    title={titleText} aria-label={ariaLabel}
    style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      width: compact ? 60 : 104, height: compact ? 26 : 30,
      border: `1px solid ${T.border}`, borderRadius: T.radiusSm,
      background: "transparent", color: disabled ? T.light : T.dark,
      fontSize: T.fsXs, fontWeight: T.fwBold,
      cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.4 : 1,
      letterSpacing: "0.01em", whiteSpace: "nowrap", userSelect: "none", flexShrink: 0,
    }}>{label}</button>;
}
